export default function () {
    // Default to the root
    return '/';
}
